import { useMediaQuery } from '@mantine/hooks';
import React from 'react';
import { Drawer, Modal } from '../Elements';

type DisplayModalContentProps = {
  children: React.ReactNode;
  onClose: (value: boolean) => void;
  opened: boolean;
  title: string | React.ReactNode;
  trapFocus?: boolean;
  minHeight?: string;
  closeOnClickOutside?: boolean;
  className?: string;
  height?: string;
};
export const DisplayModalContent = ({
  children,
  onClose,
  opened,
  title,
  trapFocus = false,
  minHeight,
  closeOnClickOutside = true,
  className,
  height,
}: DisplayModalContentProps) => {
  const isMobile = useMediaQuery('(min-width: 768px)');

  if (isMobile === undefined) {
    return null;
  }
  return isMobile ? (
    <Modal
      title={title}
      onClose={onClose}
      opened={opened}
      trapFocus={trapFocus}
      minHeight={minHeight}
      className={className}
      closeOnClickOutside={closeOnClickOutside}
    >
      {children}
    </Modal>
  ) : (
    <Drawer
      title={title}
      onClose={onClose}
      opened={opened}
      trapFocus={trapFocus}
      closeOnClickOutside={closeOnClickOutside}
      className={className}
      height={height}
    >
      {children}
    </Drawer>
  );
};
